import { StandardPeriod } from "@acto/taskpane/core/domain";
import { PeriodOption } from "../ui/DateRangeSelector/types";

/**
 * Converts a PeriodOption to a domain StandardPeriod.
 *
 * NOTE: THIS_WEEK, THIS_MONTH, and CUSTOM don't have direct StandardPeriod equivalents
 * and will fall back to LAST_MONTH. These should be handled with custom date ranges instead.
 */
export function periodOptionToDomainStandardPeriod(period: PeriodOption): StandardPeriod {
  switch (period) {
    case PeriodOption.LAST_MONTH:
      return StandardPeriod.LAST_MONTH;
    case PeriodOption.LAST_3_MONTHS:
      return StandardPeriod.LAST_3_MONTHS;
    case PeriodOption.LAST_6_MONTHS:
      return StandardPeriod.LAST_6_MONTHS;
    case PeriodOption.LAST_12_MONTHS:
      return StandardPeriod.LAST_12_MONTHS;
    default:
      return StandardPeriod.LAST_MONTH;
  }
}
